import React from 'react';
import { Layout } from '../components/Layout';

const AboutPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative py-24 md:py-40" data-testid="about-hero">
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_maurice-flavors/artifacts/m16g5x98_Image%20Codex%2013%20sept.%202026%2C%2018_10_23.png"
            alt="L'Île Gourmande - Notre Histoire"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-secondary/60 via-secondary/40 to-secondary/70" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center text-white">
          <span className="font-accent text-2xl md:text-3xl text-primary">Notre Histoire</span>
          <h1 className="text-4xl md:text-6xl font-serif font-bold mt-4 mb-6">
            L'origine
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light">
            Tout a commencé à la maison.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 md:py-24 bg-background" data-testid="about-story">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="space-y-6 text-lg text-foreground leading-relaxed">
              <p className="text-2xl font-serif italic text-primary text-center mb-12">
                « L'Île Gourmande, c'est avant tout une histoire de famille, de souvenirs et de cuisine. »
              </p>

              <p>
                Avec nos racines mauriciennes, la cuisine a toujours eu une place importante chez nous. 
                Les recettes, les épices, les odeurs qui rappellent l'île… puis l'envie de faire découvrir 
                tout ça autour de nous, ici en Bourgogne.
              </p>

              <p>
                Au départ, c'était simplement l'envie de cuisiner et de faire plaisir. 
                Puis, petit à petit, l'idée a grandi : transformer cette passion en 
                quelque chose qui nous ressemble vraiment.
              </p>

              <p>
                Aujourd'hui, L'Île Gourmande, c'est notre façon de partager un petit bout de l'île 
                à travers nos plats, directement depuis notre cuisine.
              </p>

              <p className="text-center font-accent text-3xl md:text-4xl text-primary pt-8">
                Une histoire simple, née d'une passion.
              </p>
            </div>

            {/* Depuis 2026 badge */}
            <div className="flex justify-center mt-16">
              <div className="inline-flex items-center gap-4 px-8 py-4 bg-primary/5 border border-primary/20 rounded-full">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="font-serif font-bold text-primary text-xl">✦</span>
                </div>
                <div className="text-left">
                  <p className="text-xs text-muted-foreground uppercase tracking-wider">Depuis</p>
                  <p className="text-2xl font-serif font-bold text-primary">2026</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 bg-muted/50" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
              Nos valeurs
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold">
              Ce qui nous anime
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6">
                <span className="font-serif text-2xl text-primary">✦</span>
              </div>
              <h3 className="font-serif text-xl font-semibold mb-4">Racines</h3>
              <p className="text-muted-foreground leading-relaxed">
                Des recettes transmises en famille, avec des épices et 
                saveurs qui rappellent l'île Maurice.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6">
                <span className="font-serif text-2xl text-primary">✦</span>
              </div>
              <h3 className="font-serif text-xl font-semibold mb-4">Fait maison</h3>
              <p className="text-muted-foreground leading-relaxed">
                Tous nos plats sont préparés à la commande, avec soin et 
                des produits frais, directement depuis notre cuisine.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-6">
                <span className="font-serif text-2xl text-primary">✦</span>
              </div>
              <h3 className="font-serif text-xl font-semibold mb-4">Partage</h3>
              <p className="text-muted-foreground leading-relaxed">
                Faire plaisir, faire découvrir, et partager un peu de 
                notre culture à travers chaque plat livré.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutPage;
